import { CurriedFunction1, CurriedFunction2, CurriedFunction3, CurriedFunction4 } from 'lodash4';
import { RegularExpression } from '../core/regular_expression';
import * as _4 from 'lodash4';
import { unsafe_input } from '../core/types';

type phonenumber_human = unsafe_input;
type phonenumber_clean = string | number;
type phonenumber = string;

/**
 * handles a phonenumber {string}
 */
export class PhoneNumberUtility {
  static isValidPhoneNumber(phoneNum: phonenumber_human): boolean {
    return (
      !_4.isUndefined(phoneNum) &&
      !_4.isNull(phoneNum.match(RegularExpression.PHONE_NUMBER)) &&
      _4.inRange(phoneNum.match(RegularExpression.DIGITS).length, 10, 12)
    );
  }

  static sanitizeStandard(phoneNumber: phonenumber_clean): phonenumber {
    const phoneNumberDigits = (phoneNumber + '').match(RegularExpression.DIGITS);
    const truncatedPhoneNumber = !!phoneNumberDigits ? phoneNumberDigits.splice(0, 11).join('') : '';

    return truncatedPhoneNumber.length === 10 ? `1${truncatedPhoneNumber}` : truncatedPhoneNumber;
  }

  static formatStandard(phoneNumber: phonenumber): phonenumber {
    return `${phoneNumber.slice(0, 1)}.${phoneNumber.slice(1, 4)}.${phoneNumber.slice(4, 7)}.${phoneNumber.slice(
      7,
      11
    )}`;
  }

  static getDisplayNumber(cleanPhoneNumber: phonenumber_clean): phonenumber {
    return PhoneNumberUtility.formatStandard(PhoneNumberUtility.sanitizeStandard(cleanPhoneNumber));
  }

  static sanitizePhoneNumber = PhoneNumberUtility.sanitizeStandard;
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-type/src/types/phone_number.ts